import React, { useState, useEffect } from 'react';
import { Label } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import Button from 'react-bootstrap/Button';
import TauriSearchConfigure from './TauriSearchConfigure/TauriSearchConfigure';
import './TauriSearchDropdown.css';

const TauriSearchDropdown = ({ show, searchTerm, recentSearches, checkboxStates, onCheckboxChange, searchConfig = {}, setIsModalOpen, setShowDropdown, fetchSearchPrepare }) => {
    const [isModalOpen, setModalOpen] = useState(false);
    const [selectedConfig, setSelectedConfig] = useState(null);
    const [selectedSections, setSelectedSections] = useState([]);
    const [selectedTransactions, setSelectedTransactions] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        // Check if localStorage is empty, then initialize from searchConfig
        const storedSections = JSON.parse(localStorage.getItem('sectionsID'));
        const storedTransactions = JSON.parse(localStorage.getItem('transactionsID'));
    
        if (!storedSections && searchConfig?.sections) {
            const allSectionsIds = searchConfig?.sections.flatMap(node => node.items.map(item => item.id));
            setSelectedSections(allSectionsIds);
            localStorage.setItem('sectionsID', JSON.stringify(allSectionsIds));
        } else {
            setSelectedSections(storedSections || []);
        }
    
        if (!storedTransactions && searchConfig?.transactions) {
            const allTransactionsIds = searchConfig?.transactions.flatMap(node => node.items.map(item => item.id));
            setSelectedTransactions(allTransactionsIds);
            localStorage.setItem('transactionsID', JSON.stringify(allTransactionsIds));
        } else {
            setSelectedTransactions(storedTransactions || []);
        }
    }, [searchConfig]);
    

    const handleSearch = () => {
        let catalogs = [];
        if (checkboxStates.referenceFiles) {
            catalogs = catalogs.concat(selectedSections);
        }

        if (checkboxStates.transactions) {
            catalogs = catalogs.concat(selectedTransactions);
        }

        const searchPayload = {
            Text: searchTerm || '',
            Catalogs: catalogs,
            Condition: 'contains',
            PageIndex: 1,
            ResultsPerPage: 10,
            TransactionID: 62
        };

        const searchConfigPayload = { searchPayload, searchConfig };

        navigate('/searchresult', { state: searchConfigPayload }); //to pass payload to search result

        fetchSearchPrepare();

        setShowDropdown(false);
    };

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === 'Enter') {
                handleSearch();
            }
        };

        if (show) {
            document.addEventListener('keydown', handleKeyDown);
        }

        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [show, handleSearch]);

    const toggleModal = (configType) => {
        if (configType) {
            // Check if searchConfig and the selected config exist
            if (!searchConfig || !searchConfig[configType]) {
                return; // Return early if searchConfig is null or doesn't have the desired configType
            }

            setSelectedConfig(configType);
        }

        const newState = !isModalOpen;
        setModalOpen(newState);
        setIsModalOpen(newState);
    };


    const handleUpdate = (selectedIds) => {
        if (selectedConfig === 'sections') {
            setSelectedSections(selectedIds);
            localStorage.setItem('sectionsID', JSON.stringify(selectedIds));
        } else if (selectedConfig === 'transactions') {
            setSelectedTransactions(selectedIds);
            localStorage.setItem('transactionsID', JSON.stringify(selectedIds));
        }
        toggleModal(); // Close the modal after saving
    };

    useEffect(() => {
        if (!show) {
            setModalOpen(false); // Ensure modal is closed when dropdown is hidden
        }
    }, [show]);

    if (!show) return null;

    return (
        <div className="tauri-search-dropdown">
            <Label>{searchTerm && `Search Result for: "${searchTerm}"`}</Label>

            <div className='tauri-search-config'>
                <div className='tauri-search-row'>
                    <div className='tauri-search-cell'>
                        <input
                            type="checkbox"
                            className="circle-checkbox"
                            checked={checkboxStates.referenceFiles}
                            onChange={() => onCheckboxChange('referenceFiles')}
                        />
                    </div>
                    <div className='tauri-search-cell'>
                        Search Reference Files
                    </div>
                    <div className='tauri-search-cell configure-cell'>
                        <span className="configure-link" onClick={() => toggleModal('sections')}>Configure</span>
                    </div>
                </div>
                <div className='tauri-search-row'>
                    <div className='tauri-search-cell'>
                        <input
                            type="checkbox"
                            className="circle-checkbox"
                            checked={checkboxStates.transactions}
                            onChange={() => onCheckboxChange('transactions')}
                        />
                    </div>
                    <div className='tauri-search-cell'>
                        Search Transactions
                    </div>
                    <div className='tauri-search-cell configure-cell'>
                        <span className="configure-link" onClick={() => toggleModal('transactions')}>Configure</span>
                    </div>
                </div>
                <div className='tauri-search-row'>
                    <div className='tauri-search-cell'>
                        <input
                            type="checkbox"
                            className="circle-checkbox"
                            checked={checkboxStates.help}
                            onChange={() => onCheckboxChange('help')}
                        />
                    </div>
                    <div className='tauri-search-cell'>
                        Search in Help
                    </div>
                </div>
            </div>

            <div className='recent-searches'>
                <Label>Recent Searches</Label>
                <hr />

                <div className='recent-searches-items'>
                    {recentSearches && recentSearches.slice(0, 3).map((search, index) => (
                        <Label key={index}>
                            {search}
                        </Label>
                    ))}
                </div>
            </div>

            <div className='searchdropdown-footer'>
                <Button className="search-button" onClick={handleSearch}>
                    <div>Search</div>
                    <img src={process.env.PUBLIC_URL + "/Images/ic--outline-greater-than.svg"} alt="Icon"/>
                </Button>
            </div>

            {isModalOpen && (
                <TauriSearchConfigure
                    show={isModalOpen}
                    onHide={toggleModal}
                    onUpdate={handleUpdate}
                    data={searchConfig[selectedConfig] || []}
                    selectedConfig={selectedConfig}
                    selectedIds={selectedConfig === 'sections' ? selectedSections : selectedTransactions} // Pass the appropriate array of selected IDs
                />
            )}
        </div>
    );
};

export default TauriSearchDropdown;